module.exports = __webpack_public_path__ + "img/iaImage.231dcb95.png";